import { render, staticRenderFns } from "./EditTerms.vue?vue&type=template&id=615f6aaf&scoped=true"
import script from "./EditTerms.vue?vue&type=script&lang=js"
export * from "./EditTerms.vue?vue&type=script&lang=js"
import style0 from "./EditTerms.vue?vue&type=style&index=0&id=615f6aaf&prod&lang=css"
import style1 from "./EditTerms.vue?vue&type=style&index=1&id=615f6aaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615f6aaf",
  null
  
)

export default component.exports